import React from "react";
import { AppContents } from "./AppContents";
import { RecordToJsonWrapper } from "./global-style";

export const App = (): React.ReactElement => (
  <>
    <AppContents />
    {process.env.RECORD && (
      <RecordToJsonWrapper>
        <record-to-json heading="Record Stubs"></record-to-json>
      </RecordToJsonWrapper>
    )}
  </>
);
